/**
 * TrovvaIcon — Fun, animated Trovva brand icon
 *
 * A sparkly wand/star burst that feels alive and approachable.
 * Replaces the generic Brain icon throughout the app.
 *
 * Props:
 *   size     — icon size in px (default 20)
 *   color    — fill color (default "currentColor")
 *   animate  — enable subtle sparkle animation (default false)
 */
export default function TrovvaIcon({ size = 20, color = 'currentColor', animate = false, style = {} }) {
  const id = `trovva-sparkle-${Math.random().toString(36).slice(2, 8)}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      {animate && (
        <style>{`
          @keyframes trovvaSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          @keyframes trovvaPulse { 0%, 100% { opacity: 0.6; } 50% { opacity: 1; } }
          .trovva-orbit-${id} { animation: trovvaSpin 8s linear infinite; transform-origin: 12px 12px; }
          .trovva-pulse-${id} { animation: trovvaPulse 2s ease-in-out infinite; }
        `}</style>
      )}

      {/* Central 4-point star burst — the "magic wand" spark */}
      <path
        d="M12 2 L13.5 9.5 L20 12 L13.5 14.5 L12 22 L10.5 14.5 L4 12 L10.5 9.5 Z"
        fill={color}
        className={animate ? `trovva-pulse-${id}` : undefined}
      />

      {/* Small accent sparkles orbiting */}
      <g className={animate ? `trovva-orbit-${id}` : undefined}>
        {/* Top-right sparkle */}
        <circle cx="18.5" cy="5.5" r="1.2" fill={color} opacity="0.7" />
        {/* Bottom-left sparkle */}
        <circle cx="5.5" cy="18.5" r="0.9" fill={color} opacity="0.5" />
      </g>

      {/* Tiny diamond accents */}
      <path d="M19 17 L19.5 18 L20 17 L19.5 16 Z" fill={color} opacity="0.5" />
      <path d="M4 6 L4.5 7 L5 6 L4.5 5 Z" fill={color} opacity="0.4" />
    </svg>
  );
}
